window.initSwiper = function() {

    var swiper = [];
    $('.swiper-container').each(function(index){

        var $el = $(this);

        swiper[index] = $el.swiper({
            speed: 400,
            pagination: $el.parent().find('.swiper-pagination')[0],
            paginationClickable: true,
            nextButton: $el.parent().find('.swiper-button-next')[0],
            prevButton: $el.parent().find('.swiper-button-prev')[0],
            autoplay: 10000,
            autoplayDisableOnInteraction: false,
            simulateTouch: false,
            loop: true,
            autoHeight: true
        });

        $(window).resize(function() {

            updateSwipers();

        });

    });

}

window.updateSwipers = function() {

    $('.swiper-container').each(function() {

        this.swiper.update();
        this.swiper.slideTo();
        this.swiper.startAutoplay();

    });

}

var timeout = 0;
function unifySlides() {
  $('.swiper-container').each(function() {
    var minHeight = 99999;
    $(this).find('.swiper-slide').each(function() {
      if(parseInt($(this).outerHeight()) < minHeight) {
        minHeight = $(this).outerHeight();
      }
    });

    if(minHeight > 99) {
      $(this).find('.swiper-wrapper').css('max-height',minHeight);
    } else if(timeout < 10) {
      timeout++;
      setTimeout(unifySlides,100);
    } else {
      console.error('Unification of slides reached the maximum number of retries. Aborting.');
    }
  })
}
